export default "__VITE_ASSET__41abd311__"